define([], ()=> {
    return ['JsonRPCService', (JsonRPCService)=> {
        return {
            getProducerContactSummary: ()=> {
                return JsonRPCService.send('pc', 'profileinfo/producer', 'getProducerContactSummary', []);
            },
            getProducerContactSummaryByQuoteId: (quoteId) => {
                return JsonRPCService.send('pc', 'profileinfo/producer', 'getProducerContactSummaryByQuoteId', [quoteId]);
            },
            getProducerContactSummaryByPolicyNumber: (policyNumber) => {
                return JsonRPCService.send('pc', 'profileinfo/producer', 'getProducerContactSummaryByPolicyNumber', [policyNumber]);
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/policyjob/services/ProducerContactService.js
 **/